import { createRoot } from "react-dom/client";
import { IonApp, setupIonicReact } from '@ionic/react';
import App from "./App";
import "./index.css";
import { bootstrapSentry } from "@/lib/sentry";

// Import Ionic CSS
import '@ionic/react/css/core.css';
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

import "./variables.css";

// Setup Ionic with iOS-specific configurations
setupIonicReact({
  mode: 'ios', // Use iOS mode for consistent behavior across platforms
  animated: true,
  swipeBackEnabled: true,
  hardwareBackButton: true,
  statusTap: true,
  rippleEffect: false, // Disable ripple effect to avoid layout issues
});

bootstrapSentry();

// Start MSW in development - temporarily disabled
// if (import.meta.env.DEV) {
//   import("./mocks/browser").then(({ worker }) => {
//     worker.start({
//       onUnhandledRequest: "bypass",
//       serviceWorker: {
//         url: "/mockServiceWorker.js",
//       },
//     }).catch((error) => {
//       console.warn("MSW service worker failed to start:", error);
//     });
//   });
// }

createRoot(document.getElementById("root")!).render(
  <App />
);
